<template>
    <span v-if="registro.dias_pendientes<30">
        <span class="badge badge-danger">faltan {{registro.dias_pendientes}} días</span>
        <a v-show="registro.cel!='' &&  registro.cel!=null" :href="'https://api.whatsapp.com/send?phone=+51'+registro.cel+'&text=%20Hola%20*'+registro.propietario+'*.%0A%20tu%20certificado%20de%20'+tipo+'%20*'+registro.certificado+'*%20de%20tu%20vehículo%20placa%20*'+registro.placa_rodaje+'*;%20está%20próximo%20a%20vencer%20el%20*'+registro.fecha_expiracion+'*,%20renuevalo%20pronto.'"
            target="_blank" class="btn btn-green btn-sm "> <i class="fab fa-whatsapp fa-lg"></i></a>
    </span>
    <span v-else-if="registro.dias_pendientes>31 && registro.dias_pendientes<50">
        <span class="badge badge-warning">faltan {{registro.dias_pendientes}} días</span>
        <a v-show="registro.cel!='' &&  registro.cel!=null" :href="'https://api.whatsapp.com/send?phone=+51'+registro.cel+'&text=%20Hola%20*'+registro.propietario+'*.%0A%20tu%20certificado%20de%20'+tipo+'%20*'+registro.certificado+'*%20de%20tu%20vehículo%20placa%20*'+registro.placa_rodaje+'*;%20está%20próximo%20a%20vencer%20el%20*'+registro.fecha_expiracion+'*,%20renuevalo%20pronto.'"
            target="_blank" class="btn btn-green btn-sm "> <i class="fab fa-whatsapp fa-lg"></i></a>
    </span>
    <span v-else>
        faltan {{registro.dias_pendientes}} días
    </span>
</template>

<script>
    export default {
        name: "DiasPendientesComponent",
        props: ["registro","tipo"]

    }
</script>